<template>
<div class="chapter">
<div class="inner_page">
<div class="imgdes2">
<img src="Images/designtop.jpg"/>
</div>
<p class="D1"><span epub:type="pagebreak" id="pagexviii" title="xviii"></span>Prince Harry of Wales</p>
<p class="D2">Born September 15, 1984</p>
<p class="D3"><span epub:type="pagebreak" id="pagexix" title="xix"></span>-and-</p>
<p class="D4"><span epub:type="pagebreak" id="pagexx" title="xx"></span>Meghan Markle</p>
<p class="D5">Born August 4, 1981</p>
<div class="imgdes">
<img src="Images/designbottom.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Prince.vue?6ae14b63